/* eslint-disable no-restricted-syntax */
import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const Chrome = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ fontSize: 14 }} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        height="48"
        width="48"
      >
        <defs>
          <linearGradient
            id="chrome_a"
            x1="3.2173"
            y1="15"
            x2="44.7812"
            y2="15"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#d93025" />
            <stop offset="1" stopColor="#ea4335" />
          </linearGradient>
          <linearGradient
            id="chrome_b"
            x1="20.7219"
            y1="47.6791"
            x2="41.5039"
            y2="11.6837"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fcc934" />
            <stop offset="1" stopColor="#fbbc04" />
          </linearGradient>
          <linearGradient
            id="chrome_c"
            x1="26.5981"
            y1="46.5015"
            x2="5.8161"
            y2="10.506"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#1e8e3e" />
            <stop offset="1" stopColor="#34a853" />
          </linearGradient>
        </defs>
        <circle cx="24" cy="23.9947" r="12" fill="#fff" />
        <path
          d="M3.2154,36A24,24,0,1,0,12,3.2154,24,24,0,0,0,3.2154,36ZM34.3923,18A12,12,0,1,1,18,13.6077,12,12,0,0,1,34.3923,18Z"
          fill="none"
        />
        <path
          d="M24,12H44.7812a23.9939,23.9939,0,0,0-41.5639.0029L13.6079,30l.0093-.0024A11.9852,11.9852,0,0,1,24,12Z"
          fill="url(#chrome_a)"
        />
        <circle cx="24" cy="24" r="9.5" fill="#1a73e8" />
        <path
          d="M34.3913,30.0029,24.0007,48A23.994,23.994,0,0,0,44.78,12.0031H23.9989l-.0025.0093A11.985,11.985,0,0,1,34.3913,30.0029Z"
          fill="url(#chrome_b)"
        />
        <path
          d="M13.6086,30.0031,3.218,12.006A23.994,23.994,0,0,0,24.0025,48L34.3931,30.0029l-.0067-.0068a11.9852,11.9852,0,0,1-20.7778.007Z"
          fill="url(#chrome_c)"
        />
      </svg>
    </SvgIcon>
  );
};

export const Edge = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ fontSize: 14 }} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
        <defs>
          <radialGradient
            id="edge_b"
            cx="161.8"
            cy="68.9"
            r="95.4"
            gradientTransform="matrix(1 0 0 -.95 0 248.8)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".7" stopOpacity="0" />
            <stop offset=".9" stopOpacity=".5" />
            <stop offset="1" />
          </radialGradient>
          <radialGradient
            id="edge_d"
            cx="-340.3"
            cy="63"
            r="143.2"
            gradientTransform="matrix(.15 -.99 -.8 -.12 176.6 -125.4)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".8" stopOpacity="0" />
            <stop offset=".9" stopOpacity=".5" />
            <stop offset="1" />
          </radialGradient>
          <radialGradient
            id="edge_e"
            cx="113.4"
            cy="570.2"
            r="202.4"
            gradientTransform="matrix(-.04 1 2.13 .08 -1179.5 -106.7)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#35c1f1" />
            <stop offset=".1" stopColor="#34c1ed" />
            <stop offset=".2" stopColor="#2fc2df" />
            <stop offset=".3" stopColor="#2bc3d2" />
            <stop offset=".7" stopColor="#36c752" />
          </radialGradient>
          <radialGradient
            id="edge_f"
            cx="376.5"
            cy="568"
            r="97.3"
            gradientTransform="matrix(.28 .96 .78 -.23 -303.8 -148.5)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#66eb6e" />
            <stop offset="1" stopColor="#66eb6e" stopOpacity="0" />
          </radialGradient>
          <linearGradient
            id="edge_a"
            x1="63.3"
            y1="84"
            x2="241.7"
            y2="84"
            gradientTransform="matrix(1 0 0 -1 0 266)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#0c59a4" />
            <stop offset="1" stopColor="#114a8b" />
          </linearGradient>
          <linearGradient
            id="edge_c"
            x1="157.3"
            y1="161.4"
            x2="46"
            y2="40.1"
            gradientTransform="matrix(1 0 0 -1 0 266)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#1b9de2" />
            <stop offset=".2" stopColor="#1595df" />
            <stop offset=".7" stopColor="#0680d7" />
            <stop offset="1" stopColor="#0078d4" />
          </linearGradient>
        </defs>
        <path
          d="M235.7 195.5a93.7 93.7 0 0 1-10.6 4.7 101.9 101.9 0 0 1-35.9 6.4c-47.3 0-88.5-32.5-88.5-74.3a31.5 31.5 0 0 1 16.4-27.3c-42.8 1.8-53.8 46.4-53.8 72.5 0 74 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4a128.3 128.3 0 0 0 66.6-52.8 4 4 0 0 0-5.3-5.6Z"
          transform="translate(-4.6 -5)"
          fill="url(#edge_a)"
        />
        <path
          d="M235.7 195.5a93.7 93.7 0 0 1-10.6 4.7 101.9 101.9 0 0 1-35.9 6.4c-47.3 0-88.5-32.5-88.5-74.3a31.5 31.5 0 0 1 16.4-27.3c-42.8 1.8-53.8 46.4-53.8 72.5 0 74 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4a128.3 128.3 0 0 0 66.6-52.8 4 4 0 0 0-5.3-5.6Z"
          transform="translate(-4.6 -5)"
          opacity=".35"
          fill="url(#edge_b)"
        />
        <path
          d="M110.3 246.3A79.2 79.2 0 0 1 87.6 225a80.7 80.7 0 0 1 29.5-120c3.2-1.5 8.5-4.1 15.6-4a32.4 32.4 0 0 1 25.7 13 31.9 31.9 0 0 1 6.3 18.7c0-.2 24.5-79.6-80-79.6-43.9 0-80 41.6-80 78.2a130.2 130.2 0 0 0 12.1 56 128 128 0 0 0 156.4 67 75.5 75.5 0 0 1-62.8-8Z"
          transform="translate(-4.6 -5)"
          fill="url(#edge_c)"
        />
        <path
          d="M110.3 246.3A79.2 79.2 0 0 1 87.6 225a80.7 80.7 0 0 1 29.5-120c3.2-1.5 8.5-4.1 15.6-4a32.4 32.4 0 0 1 25.7 13 31.9 31.9 0 0 1 6.3 18.7c0-.2 24.5-79.6-80-79.6-43.9 0-80 41.6-80 78.2a130.2 130.2 0 0 0 12.1 56 128 128 0 0 0 156.4 67 75.5 75.5 0 0 1-62.8-8Z"
          transform="translate(-4.6 -5)"
          opacity=".41"
          fill="url(#edge_d)"
        />
        <path
          d="M157 153.8c-.9 1-3.4 2.5-3.4 5.6 0 2.6 1.7 5.2 4.8 7.3 14.3 10 41.4 8.6 41.5 8.6a59.6 59.6 0 0 0 30.3-8.3 61.4 61.4 0 0 0 30.4-52.9c.3-22.4-8-37.3-11.3-43.9C228 28.8 182.3 5 132.6 5a128 128 0 0 0-128 126.2c.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10a72.6 72.6 0 0 1 30.9 29.3c6.1 10.6 7.2 24.1 7.2 29.5s-2.7 13.3-7.8 19.9Z"
          transform="translate(-4.6 -5)"
          fill="url(#edge_e)"
        />
        <path
          d="M157 153.8c-.9 1-3.4 2.5-3.4 5.6 0 2.6 1.7 5.2 4.8 7.3 14.3 10 41.4 8.6 41.5 8.6a59.6 59.6 0 0 0 30.3-8.3 61.4 61.4 0 0 0 30.4-52.9c.3-22.4-8-37.3-11.3-43.9C228 28.8 182.3 5 132.6 5a128 128 0 0 0-128 126.2c.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10a72.6 72.6 0 0 1 30.9 29.3c6.1 10.6 7.2 24.1 7.2 29.5s-2.7 13.3-7.8 19.9Z"
          transform="translate(-4.6 -5)"
          fill="url(#edge_f)"
        />
      </svg>
    </SvgIcon>
  );
};

export const Brave = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ fontSize: 14 }} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="64"
        viewBox="0 0 56 64"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.292 15.321l1.5-3.676s-1.909-2.043-4.227-4.358c-2.317-2.315-7.225-.953-7.225-.953L37.751 0H18.12l-5.589 6.334s-4.908-1.362-7.225.953C2.988 9.602 1.08 11.645 1.08 11.645l1.5 3.676-1.91 5.447s5.614 21.236 6.272 23.83c1.295 5.106 2.181 7.08 5.862 9.668 3.68 2.587 10.36 7.08 11.45 7.762 1.091.68 2.455 1.84 3.682 1.84 1.227 0 2.59-1.16 3.68-1.84 1.091-.681 7.77-5.175 11.452-7.762 3.68-2.587 4.567-4.562 5.862-9.668.657-2.594 6.27-23.83 6.27-23.83l-1.908-5.447z"
          fill="url(#paint0_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.888 11.508c.818 0 6.885-1.157 6.885-1.157s7.189 8.68 7.189 10.536c0 1.534-.619 2.134-1.347 2.842-.152.148-.31.3-.467.468l-5.39 5.717a9.42 9.42 0 01-.176.18c-.538.54-1.33 1.336-.772 2.658l.115.269c.613 1.432 1.37 3.2.407 4.99-1.025 1.906-2.78 3.178-3.905 2.967-1.124-.21-3.766-1.589-4.737-2.218-.971-.63-4.05-3.166-4.05-4.137 0-.809 2.214-2.155 3.29-2.81.214-.13.383-.232.48-.298.111-.075.297-.19.526-.332.981-.61 2.754-1.71 2.799-2.197.055-.602.034-.778-.758-2.264-.168-.316-.365-.654-.568-1.004-.754-1.295-1.598-2.745-1.41-3.784.21-1.173 2.05-1.845 3.608-2.415.194-.07.385-.14.567-.209l1.623-.609c1.556-.582 3.284-1.229 3.57-1.36.394-.181.292-.355-.903-.468a54.655 54.655 0 01-.58-.06c-1.48-.157-4.209-.446-5.535-.077-.261.073-.553.152-.86.235-1.49.403-3.317.897-3.493 1.182-.03.05-.06.093-.089.133-.168.238-.277.394-.091 1.406.055.302.169.895.31 1.629.41 2.148 1.053 5.498 1.134 6.25.011.106.024.207.036.305.103.84.171 1.399-.805 1.622l-.255.058c-1.102.252-2.717.623-3.3.623-.584 0-2.2-.37-3.302-.623l-.254-.058c-.976-.223-.907-.782-.804-1.622.012-.098.024-.2.035-.305.081-.753.725-4.112 1.137-6.259.14-.73.253-1.32.308-1.62.185-1.012.076-1.168-.092-1.406a3.743 3.743 0 01-.09-.133c-.174-.285-2-.779-3.491-1.182-.307-.083-.6-.162-.86-.235-1.327-.37-4.055-.08-5.535.077-.226.024-.422.045-.58.06-1.196.113-1.297.287-.903.468.285.131 2.013.778 3.568 1.36.597.223 1.17.437 1.624.609.183.069.373.138.568.21 1.558.57 3.398 1.241 3.608 2.414.187 1.039-.657 2.489-1.41 3.784-.204.35-.4.688-.569 1.004-.791 1.486-.812 1.662-.757 2.264.044.488 1.816 1.587 2.798 2.197.229.142.415.257.526.332.098.066.266.168.48.298 1.076.654 3.29 2 3.29 2.81 0 .97-3.078 3.507-4.05 4.137-.97.63-3.612 2.008-4.737 2.218-1.124.21-2.88-1.061-3.904-2.966-.963-1.791-.207-3.559.406-4.99l.115-.27c.559-1.322-.233-2.118-.772-2.658a9.377 9.377 0 01-.175-.18l-5.39-5.717c-.158-.167-.316-.32-.468-.468-.728-.707-1.346-1.308-1.346-2.842 0-1.855 7.189-10.536 7.189-10.536s6.066 1.157 6.884 1.157c.653 0 1.913-.433 3.227-.885.333-.114.669-.23 1-.34 1.635-.545 2.726-.549 2.726-.549s1.09.004 2.726.549c.33.11.667.226 1 .34 1.313.452 2.574.885 3.226.885zm-1.041 30.706c1.282.66 2.192 1.128 2.536 1.343.445.278.174.803-.232 1.09-.405.285-5.853 4.499-6.381 4.965l-.215.191c-.509.459-1.159 1.044-1.62 1.044-.46 0-1.11-.586-1.62-1.044l-.213-.191c-.53-.466-5.977-4.68-6.382-4.966-.405-.286-.677-.81-.232-1.09.344-.214 1.255-.683 2.539-1.344l1.22-.629c1.92-.992 4.315-1.837 4.689-1.837.373 0 2.767.844 4.689 1.837.436.226.845.437 1.222.63z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.34 6.334L37.751 0H18.12l-5.589 6.334s-4.908-1.362-7.225.953c0 0 6.544-.59 8.793 3.064 0 0 6.066 1.157 6.884 1.157.818 0 2.59-.68 4.226-1.225 1.636-.545 2.727-.549 2.727-.549s1.09.004 2.726.549 3.408 1.225 4.226 1.225c.818 0 6.885-1.157 6.885-1.157 2.249-3.654 8.792-3.064 8.792-3.064-2.317-2.315-7.225-.953-7.225-.953z"
          fill="url(#paint1_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1=".671"
            y1="64.319"
            x2="55.2"
            y2="64.319"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F50" />
            <stop offset=".41" stopColor="#F50" />
            <stop offset=".582" stopColor="#FF2000" />
            <stop offset="1" stopColor="#FF2000" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="6.278"
            y1="11.466"
            x2="50.565"
            y2="11.466"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF452A" />
            <stop offset="1" stopColor="#FF2000" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export const Opera = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ fontSize: 14 }} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 291.492 291.492"
      >
        <g>
          <path
            fill="#E2574C"
            d="M224.138,22.932C202.571,8.166,175.879,0,145.782,0c-27.53,0-52.201,6.81-72.73,19.263   C33.534,42.997,9.199,87.423,9.199,144.349c0,76.999,54.613,147.143,136.556,147.143c81.933,0,136.538-70.126,136.538-147.143   C282.284,90.227,260.289,47.403,224.138,22.932z M145.773,27.193c43.953,0,54.586,61.068,54.586,116.537   c0,51.4-6.664,120.178-54.058,120.178s-55.214-69.452-55.214-120.843C91.096,87.596,101.811,27.193,145.773,27.193z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};

export const Generic = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ fontSize: 14 }} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 14 14"
        role="img"
        focusable="false"
        aria-hidden="true"
      >
        <path d="m 10.427082,10.030747 2.404897,-0.479349 -6.0247667,-3.753831 -0.1421156,0.09901 1.3413612,6.968904 1.3093269,-2.071742 1.2697212,1.849832 c 0.24113,0.3483 0.683785,0.460711 0.990731,0.25045 0.3052,-0.210844 0.359948,-0.665147 0.120565,-1.014029 l -1.26972,-1.84925 z m -3.5004694,1.779357 c -0.9662692,0 -1.8667227,-0.277242 -2.6349621,-0.749602 0.6913572,0.007 -0.5142952,-1.051888 0.3162653,-1.214389 C 5.4792473,9.674876 5.846185,8.678319 5.5671958,8.693463 5.2887891,8.708024 4.758768,8.5496 4.3860059,8.081318 4.0126613,7.609541 3.6859121,7.717292 3.3009187,7.791262 2.9642679,7.85766 2.5495701,8.831501 2.446478,9.087193 2.1843797,8.585129 2.0067352,8.033558 1.9263584,7.450534 2.35387,7.226877 3.051634,6.85062 3.3038309,6.642689 3.6754281,6.334578 3.179771,6.209935 3.1186147,6.024137 c -0.060574,-0.185799 0,-0.618552 0,-1.048394 0,-0.433918 0.865507,-0.433918 1.1724533,-0.865507 C 4.5118131,3.802125 4.1075992,3.122417 3.8554023,2.754314 4.7075132,2.0984858 5.7710501,1.7041734 6.9266126,1.7041734 c 0.3063639,0 0.605156,0.032034 0.8969589,0.084454 C 7.9091905,2.3209783 8.0874171,3.053106 8.4316396,3.244147 8.9890355,3.55284 9.6635019,4.232549 9.9127866,4.354861 10.160906,4.478339 10.467853,5.530227 10.407279,5.962398 10.363599,6.267597 9.9850092,6.603665 9.83008,6.92692 l 2.574389,1.604042 c 0.181721,-0.559143 0.2819,-1.153815 0.2819,-1.77295 0,-3.175467 -2.584872,-5.7580094 -5.7591739,-5.7580094 -3.1760497,-1e-7 -5.7591746,2.5825424 -5.7591746,5.7580094 0,3.17605 2.5831249,5.759757 5.7591746,5.759757 0.1205652,0 0.2382183,-0.01107 0.3570362,-0.01806 L 7.1496875,11.798455 c -0.074553,0.0035 -0.14794,0.01165 -0.2230749,0.01165 z M 11.917548,7.503536 C 11.808632,7.071365 11.597787,6.654338 11.149308,6.332248 10.842362,6.11558 10.591913,5.159212 10.778294,4.849354 10.88954,4.66472 11.179012,4.502219 11.392187,4.400874 c 0.373344,0.704171 0.586517,1.50561 0.586517,2.357138 0,0.253944 -0.02505,0.501482 -0.06116,0.745524 z m -2.604093,4.490036 c 0.012231,-0.0064 0.025045,-0.01223 0.037276,-0.01806 -0.00466,-0.007 -0.00932,-0.01281 -0.013396,-0.0198 -0.00699,0.01107 -0.016308,0.02621 -0.02388,0.03786 z" />
      </svg>
    </SvgIcon>
  );
};
